import type { ApplePayShippingMethod } from '../../typings/apple.types';

const getSelectedShippingMethod = (
    appleShippingMethods?: ApplePayShippingMethod[],
): ApplePayShippingMethod | undefined => {
    return appleShippingMethods?.find(({ selected }) => selected);
};

export default getSelectedShippingMethod;
